module.exports = __webpack_public_path__ + "static/img/half-circle-2.2bbe63d7.svg";